import { render, staticRenderFns } from "./CustomPointsSidebar.vue?vue&type=template&id=38cbbf10&scoped=true"
import script from "./CustomPointsSidebar.vue?vue&type=script&lang=js"
export * from "./CustomPointsSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomPointsSidebar.vue?vue&type=style&index=0&id=38cbbf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbbf10",
  null
  
)

export default component.exports